import React, { useEffect } from "react";

export const Seo = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = `${title} | Rossi Ceramics`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
};

export default Seo;
